import React, { Component } from 'react';
import {Link, useLocation} from "react-router-dom";

export default function AllBrandsTable({brands}){
    return(
        <>

            <div className="rounded-lg border border-gray-200 dark:border-gray-700">
            <div className="overflow-x-auto rounded-t-lg">
                <table className="min-w-full divide-y-2 divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800">
                <thead className="text-left bg-gray-50 dark:bg-gray-700">
                    <tr className="uppercase text-xs">
                        <th className="whitespace-nowrap px-4 py-2 text-gray-700 dark:text-gray-300">Brand Name</th>
                        <th className="whitespace-nowrap px-4 py-2 text-gray-700 dark:text-gray-300">Industry</th>
                        <th className="whitespace-nowrap px-4 py-2 text-gray-700 dark:text-gray-300">Company Name</th>
                        <th className="whitespace-nowrap px-4 py-2 text-gray-700 dark:text-gray-300">Active Projects</th>
                        <th className="whitespace-nowrap px-4 py-2 text-gray-700 dark:text-gray-300">Pending Projects</th>
                    </tr>
                </thead>

                <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                {brands && brands.length > 0 ? (
                    brands.map(brand => (
                        <tr className="capitalize odd:bg-white dark:odd:bg-gray-800 even:bg-gray-50 dark:even:bg-gray-700/50 hover:bg-gray-100 dark:hover:bg-gray-700" key={brand.id}>
                            <td className="whitespace-nowrap px-4 py-2 font-medium underline"><Link to={`/manage/brand/${brand.id}`} className="text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-400">{brand.brand_name}</Link></td>
                            <td className="whitespace-nowrap px-4 py-2 text-gray-700 dark:text-gray-300">{brand.industry}</td>
                            <td className="whitespace-nowrap px-4 py-2 text-gray-700 dark:text-gray-300">{brand.company.name}</td>
                            <td className="whitespace-nowrap px-4 py-2 text-gray-700 dark:text-gray-300">{brand.activeProjects} active projects</td>
                            <td className="whitespace-nowrap px-4 py-2 text-gray-700 dark:text-gray-300">{brand.pendingProjects} pending projects</td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="6" className="px-4 py-2 text-center text-gray-500 dark:text-gray-400">No companies found.</td>
                    </tr>
                )}
                    
                </tbody>
                </table>
            </div>

            <div className="rounded-b-lg border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 px-4 py-2">
                <ol className="flex justify-end gap-1 text-xs font-medium">
                <li>
                    <a href="#" className="inline-flex size-8 items-center justify-center rounded border border-gray-100 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-700 rtl:rotate-180" >
                    <span className="sr-only">Prev Page</span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                    </a>
                </li>

                <li>
                    <a href="#" className="block size-8 rounded border border-gray-100 dark:border-gray-600 bg-white dark:bg-gray-800 text-center leading-8 text-gray-900 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-700">1</a>
                </li>

                <li className="block size-8 rounded border-blue-600 dark:border-blue-500 bg-blue-600 dark:bg-blue-500 text-center leading-8 text-white">
                    2
                </li>

                <li>
                    <a
                    href="#"
                    className="block size-8 rounded border border-gray-100 dark:border-gray-600 bg-white dark:bg-gray-800 text-center leading-8 text-gray-900 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-700"
                    >
                    3
                    </a>
                </li>

                

                <li>
                    <a href="#" className="inline-flex size-8 items-center justify-center rounded border border-gray-100 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-700 rtl:rotate-180">
                    <span className="sr-only">Next Page</span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                    </svg>
                    </a>
                </li>
                </ol>
            </div>
            </div>

        </>
    )
}